import React from "react";
import { Mechanism } from "../../services/mechanismsClient";

interface GraphEvidenceTabProps {
  mechanism: Mechanism;
}

export const GraphEvidenceTab: React.FC<GraphEvidenceTabProps> = ({
  mechanism,
}) => {
  // Extract graph evidence data
  const graphEvidenceEntries = mechanism.paths || [];

  if (graphEvidenceEntries.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500 dark:text-gray-400">
        <div className="text-6xl mb-4">🔗</div>
        <p>No graph evidence available for this mechanism</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {graphEvidenceEntries.map((pathEntry, index) => (
        <div
          key={index}
          className="bg-white dark:bg-gray-800 border-l-4 border-blue-400 dark:border-blue-500 rounded-lg overflow-hidden"
        >
          {/* Path Header */}
          <div className="bg-blue-50 dark:bg-blue-950 px-6 py-4">
            <div className="flex items-center gap-2">
              <span className="text-orange-500 dark:text-orange-400 text-xl">
                ◆
              </span>
              <h3 className="text-lg font-semibold text-blue-700 dark:text-blue-300">
                {pathEntry.path}
              </h3>
            </div>
          </div>

          {/* Functional Summary */}
          <div className="px-6 py-6">
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              {pathEntry.functional_summary}
            </p>
          </div>

          {/* Additional Info - Pathomechanisms */}
          {pathEntry.pathomechanisms &&
            pathEntry.pathomechanisms.length > 0 && (
              <div className="px-6 pb-6">
                <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
                  Pathomechanisms:
                </h4>
                <div className="flex flex-wrap gap-2">
                  {pathEntry.pathomechanisms.map((mechanism, idx) => (
                    <span
                      key={idx}
                      className="px-3 py-1 bg-indigo-100 dark:bg-indigo-900 text-indigo-800 dark:text-indigo-200 text-sm font-medium rounded-full"
                    >
                      {mechanism}
                    </span>
                  ))}
                </div>
              </div>
            )}
        </div>
      ))}
    </div>
  );
};
